var React = require('react');

function OutOfStock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0C4.4766 0 0 4.4766 0 10C0 15.5234 4.4766 20 10 20C15.5234 20 20 15.5234 20 10C20 4.4766 15.5234 0 10 0ZM15.8101 14.0222L14.0222 15.8101L10.0027 11.7906L5.98323 15.8101L4.19529 14.0222L8.21747 10L4.19529 5.97782L5.98323 4.18988L10.0027 8.20936L14.0222 4.18988L15.8101 5.97782L11.7879 10L15.8101 14.0222Z","fill":"#E80606"}));
}

OutOfStock.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = OutOfStock;

OutOfStock.default = OutOfStock;
